import React from "react";
import { EditorFieldRow } from "../../../../ui/EditorField";
import { PanelSection } from "../../../../ui/PanelShell";
import { useMapEditorActions } from "../../../contexts/MapEditorContext";
import { DragNumberInput } from "../../controls/ScrollDragNumberInput";
import { ShapeSectionOptions } from "./ShapePanel";

export const RectPanelControls: React.FC<ShapeSectionOptions> = ({
  shapes
}) => {
  const { updateShape } = useMapEditorActions();
  const shape = shapes[0];

  const handleCornerRadiusChangeValue = (value: number | string) => {
    shapes.forEach((shape) => {
      updateShape(shape.id, {
        cornerRadius: Number.parseInt(String(value), 10)
      });
    });
  };

  return (
    <PanelSection label="Corners">
      <EditorFieldRow label="Edge rounding">
        <DragNumberInput
          size={"sm"}
          className="w-20"
          value={shape.cornerRadius || 0}
          onChange={handleCornerRadiusChangeValue}
          min={0}
        />
      </EditorFieldRow>
    </PanelSection>
  );
};
